module.exports = __webpack_public_path__ + "static/media/eye.386033fd.svg";